import { CircularProgress } from "@material-ui/core";
import React from "react";

import { SubformProps } from "../../../components/SubformProps";
import { isSubmitButtonEnabled } from "../../../utils/utility";
import { Button, ButtonProps } from "./Button";

export interface SubmitButtonProps extends SubformProps<any>, ButtonProps {
  isSubmitting: boolean;
  submitForm: (() => Promise<void>) & (() => Promise<any>);
}

export const SubmitButton = (props: SubmitButtonProps) => {
  const {
    disabled,
    errors,
    isSubmitting,
    submitForm,
    touched,
    value,
    values,
  } = props;

  const childProps = { ...props } as any;
  delete childProps.submitForm;
  delete childProps.isSubmitting;

  return (
    <Button
      {...childProps}
      onClick={submitForm}
      disabled={
        disabled ||
        !isSubmitButtonEnabled(
          touched,
          errors,
          Object.keys(values)
        ) ||
        isSubmitting
      }
      value={isSubmitting ? <CircularProgress color="primary" /> : value}
    />
  );
}
